import { FC } from 'react';

import { Tag, TagVariant } from '../../../components/tag/index';
import { DividendPayoutStatus } from '../../../hooks/dividend/dividend.types';
import { getTranslation } from '../../../utils/get-translation.util';

const statusVariantMap: Record<DividendPayoutStatus, TagVariant> = {
  [DividendPayoutStatus.APPROVED]: TagVariant.GRAY,
  [DividendPayoutStatus.PAID_OUT]: TagVariant.BLUE,
  [DividendPayoutStatus.PENDING]: TagVariant.YELLOW,
};

const statusLabelMap: Record<DividendPayoutStatus, string> = {
  [DividendPayoutStatus.APPROVED]: getTranslation('DIVIDEND_STATUS_APPROVED'),
  [DividendPayoutStatus.PAID_OUT]: getTranslation('DIVIDEND_STATUS_PAID_OUT'),
  [DividendPayoutStatus.PENDING]: getTranslation('DIVIDEND_STATUS_PENDING'),
};

export const DividendStatusTag: FC<{ status: DividendPayoutStatus }> = ({ status }) => (
  <Tag title={statusLabelMap[status]} variant={statusVariantMap[status]} />
);
